import { c as _c } from "react/compiler-runtime";
import { PlayIcon } from '@systemeio/icons';
import { actionCategoryOrder, ActionItem } from 'modules/automation-rules/actions/constants/action-items';
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum';
import { RulePickerModal } from 'modules/automation-rules/components/rule-picker-modal';
import React from 'react';
import { IconTile } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AddActionModalProps {
  opened: boolean;
  onClose: () => void;
  onAddAction: (action: AutomationRuleActionsEnum) => void;
  items: ActionItem[];
}
const AddActionModal = t0 => {
  const $ = _c(14);
  const {
    opened,
    onClose,
    onAddAction,
    items
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconTile tone="lightGreen"><PlayIcon /></IconTile>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.automation_rule.edit.add_action");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="flex items-center gap-2.5">{t1}<span>{t2}</span></span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onAddAction || $[6] !== onClose) {
    t4 = slug => {
      onAddAction(slug);
      onClose();
    };
    $[5] = onAddAction;
    $[6] = onClose;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== items || $[9] !== onClose || $[10] !== opened || $[11] !== t3 || $[12] !== t4) {
    t5 = <RulePickerModal title={t3} opened={opened} onClose={onClose} categoryOrder={actionCategoryOrder} dataTest="automation-rule-action-option" items={items} onSelect={t4} />;
    $[8] = items;
    $[9] = onClose;
    $[10] = opened;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default AddActionModal;